module.exports = __webpack_public_path__ + "static/media/upload_icon.c0e4b6d4.svg";